import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { NumberTagFragmentDoc } from './NumberTag';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { IntegrationProviderLiteFragmentDoc } from '../../../../../../integrations/graphql/fragments/generated/IntegrationProviderLite';
export type NumberTagWithIntegrationProviderFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, numberType: Types.NumberTagTypeEnum, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { availableInLibrary: boolean, requiredTag: boolean, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type NumberTagWithIntegrationProviderFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const NumberTagWithIntegrationProviderFragmentDoc = /*#__PURE__*/ gql`
    fragment NumberTagWithIntegrationProvider on NumberTagType {
  ...NumberTag
  integrationProvider {
    ...IntegrationProviderLite
  }
}
    `;